'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.definePropertiesMap = definePropertiesMap;
exports.getType = getType;
exports.checkSearchArguments = checkSearchArguments;
exports.groupBy = groupBy;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Function to remap propeties of Object
 * @param {Object} mapProp --> relationship between properties
 * @return {Function} --> function that receives an object to map
 */
function definePropertiesMap(mapProp) {
  var _mapProp = mapProp;

  return function (elem) {

    var obj = {};

    for (var prop in _mapProp) {
      if (_typeof(_mapProp[prop]) === _typeof(String())) {
        obj[prop] = elem[_mapProp[prop]];
      }
      if (Function.prototype.isPrototypeOf(_mapProp[prop])) {
        obj[prop] = _mapProp[prop].call(this, elem);
      }
    }

    return obj;
  };
}

function getType(elem) {
  return Object.prototype.toString.call(elem);
}

function checkSearchArguments(opts) {
  var data = new FormData();

  if (!FormData.prototype.isPrototypeOf(opts)) {
    for (var paramsKey in opts) {
      data.append(paramsKey, opts[paramsKey]);
    }
  } else {
    data = opts;
  }

  return data;
}

function groupBy(obj, iterator) {
  var _this = this;

  var _iterator = function _iterator(item) {
    return item[iterator];
  };
  if (getType(iterator) === '[object Function]') {
    _iterator = iterator;
  }

  return [].concat(_toConsumableArray(obj)).reduce(function (acc, item) {
    var _key = _iterator.call(_this, item);
    if (!acc[_key]) {
      acc[_key] = [];
    }
    acc[_key].push(item);
    return acc;
  }, {});
}